import { render, staticRenderFns } from "./PublicationsPage.vue?vue&type=template&id=7fdd95ce&scoped=true&"
import script from "./PublicationsPage.vue?vue&type=script&lang=js&"
export * from "./PublicationsPage.vue?vue&type=script&lang=js&"
import style0 from "./PublicationsPage.vue?vue&type=style&index=0&id=7fdd95ce&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7fdd95ce",
  null
  
)

export default component.exports